import { Injectable } from '@angular/core';

// Service
import { NetworkService } from './../../infrastructure/network.service';
import { ConfigService } from './../../infrastructure/config.service';

@Injectable({
  providedIn: 'root'
})
export class LineItemAvailabilityService {
  constructor(private configService: ConfigService,
    private networkService: NetworkService) {
  }

  // Get products
  public getProducts(productFilters) {
    return this.networkService.postRequest(this.configService.getProductsUrl(), productFilters);
  }

  // Get products Availability
  public getProductsAvailability(checkAvailabiltyItems) {
    return this.networkService.postRequest(this.configService.getProductsAvailabilityReportUrl(), checkAvailabiltyItems);
  }

  // Get Product Availability Email Report
  public getProductsAvailabilityEmailReport(filters) {
    return this.networkService.postRequest(this.configService.getProductsAvailabilityEmailReportUrl(), filters);
  }

  // Get accounts
  public getAccounts() {
    return this.networkService.getRequest(this.configService.getReportAccountListUrl());
  }

  // Get accounts
  public getQuickSearchData(filter) {
    return this.networkService.postRequest(this.configService.getQuickSearchReportFilterUrl(), filter);
  }
}
